import { Box } from "@mui/material";
import { TemplateDto } from "@/dto/TemplatesDto";
import useTemplateList from "./useTemplateList";
import Template from "@/organism/Template";

export type ListProps = {
  isLoading: boolean;
  templateList: TemplateDto[];
};

export const List = (props: ListProps) => {
  const { isLoading, templateList } = props;

  const { handleDetailPage } = useTemplateList();

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Template.List
        isLoading={isLoading}
        templateList={templateList}
        onDetail={handleDetailPage}
      />
    </Box>
  );
};
